import {AfterViewChecked, Component, Inject, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {select, Store} from '@ngrx/store';
import {loadAllMitarbeiterStart} from '../../../Mitarbeiterverwaltung/store/actions/getAllMitarbeiter.actions';
import {State} from '../../store/reducer/landingpage.reducer';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {addDashboardStart} from '../../store/actions/dashboard-add.actions';
import {ProjektState} from '../../../projektverwaltung/store/reducer/projektverwaltung.reducer';
import {loadNodesStart} from '../../../projektverwaltung/store/actions/getAllNodes.actions';
import {NodeItem} from '../../../projektverwaltung/node.model';
import {loadUserNodesStart} from '../../../projektverwaltung/store/actions/getUserNodes.actions';
import {Zeitstate} from '@src/app/pages/Zeiterfassung/store/reducer/zeiterfassung.reducer';
import {loadProjektSelectboxStart} from '@src/app/pages/Zeiterfassung/store/actions/project-selectbox.actions';
import {loadCacheStart} from '@src/app/pages/Zeiterfassung/store/actions/getCacheNodes.actions';
import {ZeiterfassungStufenComponent} from '@src/app/pages/Zeiterfassung/components/zeiterfassung-stufen/zeiterfassung-stufen.component';

export interface DialogData{
  id: number;
  title: string;
  submitButtonLabel: string;
  cancelButtonLabel: string;
}

@Component({
  selector: 'app-addbutton-formdialog',
  templateUrl: './addButton-formdialog.component.html',
  styleUrls: ['./addButton-formdialog.component.scss']
})

export class AddButtonFormdialogComponent implements OnInit, AfterViewChecked {
  color: any;
  $projekte;
  $nodes;
  arrOpen = [];
  private daten: any;


  constructor(
    public dialogRef: MatDialogRef<AddButtonFormdialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private store: Store<{ landingpage: State }>,
    private projekt: Store<{ projektverwaltung: ProjektState }>,
    public zeiterfassung: Store<{zeiterfassung: Zeitstate}>,
  )
  {
    dialogRef.disableClose = true;
    this.$projektSelectbox = zeiterfassung.pipe(select((state) => state.zeiterfassung.selectboxProjekte));
    this.$cache = zeiterfassung.pipe(select((state) => state.zeiterfassung.cacheNodes));
    this.$nodes = projekt.pipe(select((state) => state.projektverwaltung.usernodes.items));
  }
  public $projektSelectbox;
  public $cache;
  @ViewChild(ZeiterfassungStufenComponent) stufe;

  public addButtonForm = new FormGroup({
    cache: new FormControl(''),
    color: new FormControl(''),
    projektstufe0: new FormControl(''),
    letzteProjektstufe: new FormControl(''),
    id: new FormControl(''),
  });


  public handleSubmitClick(): void{
    const item = this.addButtonForm.value;
    if (this.data.id) {

    } else {
      item.projektstufe0 = this.daten.value.projektstufe0;
      // get highest projektstufe
      item.letzteProjektstufe = this.getLastProjektstufe();
      this.store.dispatch(addDashboardStart({item}));
    }
    this.dialogRef.close(true);
  }

  public handleCancelClick(): void{
    this.dialogRef.close(true);
  }

  public ngAfterViewChecked(){
    this.daten = this.stufe.addButtonForm;
  }

  public loadProjektstufe(projekt: NodeItem): void{
    // arrOpen leeren bis zu dem Punkt wo wir das neue Projekt abspeichern.
    // ( Bei einem Projekt von Level 1 wird alles ausser die 0te Stelle des Arrays gelöscht/weggeschnitten )
    this.arrOpen.splice(parseInt(projekt.level));
    // Einfügen des Projektes an Obersten Stelle des Arrays falls das Projekt noch Kinder hat.
    // Wenn das nicht der Fall ist wird NULL eingefügt.
    // die rechte Seite des Codes auf der nächsten Linie bedeutet: Falls projekt keine Kinder hat dann: null Sonst: projekt
    this.arrOpen[projekt.level] = !projekt.children[0]?.name ? null : projekt;
  }

  ngOnInit(): void {
    this.store.dispatch(loadUserNodesStart());
    this.store.dispatch(loadCacheStart());
  }

  public selectProjects(projektId: number): void {
    this.store.dispatch(loadProjektSelectboxStart({projektId}));
  }

  public getLastProjektstufe(): NodeItem{
    // tslint:disable-next-line:prefer-const
    let projektStufe;
    let letzteStufe;
    for (let i = 0; i < 1000; i++){
      const testString = 'projektStufe = this.daten.value.projektstufe' + i;
      // tslint:disable-next-line:no-eval
      eval(testString);
      if (projektStufe?.children?.length === 0){
        letzteStufe = projektStufe;
        return letzteStufe;
      }
      else if (projektStufe !== undefined && projektStufe !== ''){
        letzteStufe = projektStufe;

      }
      else{
        return letzteStufe;
      }
    }
  }

}
